import { render, staticRenderFns } from "./FormResetZafiro.vue?vue&type=template&id=2e8988ea&scoped=true&"
var script = {}
import style0 from "./FormResetZafiro.vue?vue&type=style&index=0&id=2e8988ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8988ea",
  null
  
)

export default component.exports